export default {
    auth: {
        token: 'auth.token'
    }
};
